<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <span>Место проведения</span>
        <LocationAutocomplete
          :address="listItem.data.address"
          :loading="isLoading"
          :error-messages="errorMessages.address"
          @set-location="mixChangeListItemHandler($event, 'address')"
          @update-location-part="mixChangeListItemHandler($event.value, `address.${$event.fieldName}`)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <span>Масштаб: <b>{{ listItem.data.zoom }}</b></span>
        <v-slider
          step="1"
          thumb-label
          ticks
          min="1"
          max="19"
          :value="listItem.data.zoom"
          @change="mixChangeListItemHandler($event, 'zoom')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'
import LocationAutocomplete from '@/components/location-autocomplete'
export default {
  name: 'MapWidget',
  mixins: [dynamicListItemMix],
  components: {
    LocationAutocomplete
  }
}
</script>
